import React from "react";
import type { TFunction } from "i18next";
import { ResourceEnum } from "src/constants/constants.ts";
import type { Module } from "src/system/module.types.ts";
import type { WarehouseResource } from "@exonn/js-sdk";

export const module: Module<WarehouseResource> = {
  id: ResourceEnum.Warehouse,
  bigIcon: <i className={"icon-20-storage_adm"} />,
  smallIcon: <i className={"icon-15-storage_adm"} />,
  name: (t: TFunction) => t("moduleName.warehouse"),
  tabs: {
    edit: {
      getTitle: (resource) => resource.title,
    },
  },
  formTabs: {
    general: {
      title: (t) => t("formTabs.general.title"),
    },
    storageSchema: {
      title: (t) => t("formTabs.storageScheme.title"),
      routeObject: {
        lazy: () =>
          import(
            "src/admin/modules/warehouse/routes/edit/tabs/storage-scheme/storage-scheme.route.tsx"
          ),
      },
    },
  },
};
